export default __webpack_public_path__ + "static/media/printer-xxl.ca9df52a.svg";